import Enumerable from "linq";
import { IBarcodeItem } from "../../../../formatEditor/domain/editableFormat/objects";

export class BarcodeItems {
  constructor(
    public barcodeItems: BarcodeItem[],
  ) {
  }
  
  clone(): BarcodeItems {
    return new BarcodeItems(this.barcodeItems.concat());
  }

  static from(source: IBarcodeItem[]): BarcodeItems {
    return new BarcodeItems(Enumerable.from(source).select(s => BarcodeItem.from(s)).toArray());
  }

  static to(source: BarcodeItems): IBarcodeItem[] {
    return Enumerable.from(source.barcodeItems).select(s => BarcodeItem.to(s)).toArray();
  }
}

export class BarcodeItem {
  constructor(
    public isHisItem: boolean,
    public value: string,
  ) {
  }

  clone(): BarcodeItem {
    return new BarcodeItem(this.isHisItem, this.value);
  }

  static from(source: IBarcodeItem): BarcodeItem {
    return new BarcodeItem(source.isHisItem, source.value);
  }

  static to(source: BarcodeItem): IBarcodeItem {
    return {
      isHisItem: source.isHisItem,
      value: source.value,
    };
  }
}
